import React from 'react';

const Meter = ({ value, label, type = 'blue' }) => {
  const color = type === 'blue' ? 'bg-[#00f0ff]' : type === 'orange' ? 'bg-[#ff5500]' : 'bg-green-500';
  const shadow = type === 'blue' ? 'shadow-[0_0_10px_#00f0ff]' : type === 'orange' ? 'shadow-[0_0_10px_#ff5500]' : '';

  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="flex justify-between text-[10px] font-mono text-gray-400 uppercase tracking-wider">
        <span>{label}</span>
        <span>{value}%</span>
      </div>
      <div className="h-1.5 w-full bg-[#1a1a2e] rounded-full overflow-hidden">
        <div 
          className={`h-full ${color} ${shadow} transition-all duration-1000 ease-out`}
          style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
        />
      </div>
    </div>
  );
};

export default Meter;